import React from 'react';

const Vue_Component_Instance_parent = () => {
  return (
    <div>
      <h1>Vue_Component_Instance_parent Component</h1>
      <p>This is the Vue_Component_Instance_parent tutorial page.</p>
    </div>
  );
}

export default Vue_Component_Instance_parent;
